import { z } from 'zod';

import {
  EXECUTION_LOG_STATUS,
  EXECUTION_LOG_TRIGGER_SOURCE,
} from '~/data/dataSubscription';

export const zodExecutionLogSearchSchema = z.object({
  contactPointId: z.uuid().optional().catch(undefined),
  limit: z.number().int().min(1).max(100).catch(25),
  page: z.number().int().min(0).catch(0),
  // One box for both: a UUID is sent as dln_id, anything else as dln_nr.
  search: z.string().optional().catch(undefined),
  status: z.enum(EXECUTION_LOG_STATUS).optional().catch(undefined),
  triggerSource: z
    .enum(EXECUTION_LOG_TRIGGER_SOURCE)
    .optional()
    .catch(undefined),
});

export const executionLogSearchDefaults = zodExecutionLogSearchSchema.parse({});
